// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__MVGa4","colMin":"styles_colMin__1HFmg","colCheckbox":"styles_colCheckbox__2f4pQ"};